import React from 'react';

const LinkValue = ({ value }) => (
  <strong className={value ? 'session-external-link-id' : 'session-external-link-empty'}>
    {value || 'Not linked'}
  </strong>
);

export const LinkRow = ({ label, value }) => (
  <div>
    <span>{label}</span>
    <LinkValue value={value} />
  </div>
);

export const LinkBadge = ({ label, linked }) => (
  <span className={`session-external-link-badge ${linked ? 'is-linked' : 'is-empty'}`}>
    {label}
  </span>
);

export const ManualIdField = ({ id, label, value, onChange, placeholder, disabled }) => (
  <>
    <label className="session-side-label" htmlFor={id}>
      {label}
    </label>
    <input
      id={id}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="session-side-select"
      placeholder={placeholder}
      disabled={disabled}
    />
  </>
);
